var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 8.10338C12.75 7.8441 12.75 7.7145 12.789 7.599C12.9024 7.26333 13.2014 7.13307 13.5008 6.99666C13.8375 6.84332 14.0058 6.76664 14.1726 6.75315C14.362 6.73784 14.5517 6.77864 14.7135 6.86947C14.9281 6.98988 15.0777 7.2187 15.2309 7.40477C15.9385 8.2641 16.2922 8.69385 16.4216 9.1677C16.5261 9.55005 16.5261 9.94995 16.4216 10.3323C16.2329 11.0234 15.6364 11.6028 15.1948 12.1391C14.969 12.4133 14.8561 12.5505 14.7135 12.6305C14.5517 12.7214 14.362 12.7622 14.1726 12.7469C14.0058 12.7334 13.8375 12.6567 13.5008 12.5033C13.2014 12.3669 12.9024 12.2367 12.789 11.901C12.75 11.7855 12.75 11.6559 12.75 11.3966V8.10338Z",
    stroke: "#8790A1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8.10345C5.25 7.77705 5.24084 7.48366 4.97693 7.25415C4.88095 7.17067 4.75369 7.11271 4.49918 6.99679C4.16251 6.84343 3.99417 6.76676 3.82737 6.75327C3.32693 6.7128 3.05769 7.05436 2.7691 7.40488C2.06156 8.26425 1.7078 8.69392 1.57835 9.16777C1.47388 9.5502 1.47388 9.9501 1.57835 10.3324C1.76715 11.0236 2.36364 11.6029 2.80516 12.1392C3.08347 12.4772 3.34933 12.7856 3.82737 12.747C3.99417 12.7335 4.16251 12.6568 4.49918 12.5035C4.75369 12.3875 4.88095 12.3295 4.97693 12.2461C5.24084 12.0166 5.25 11.7232 5.25 11.3968V8.10345Z",
    stroke: "#8790A1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.75C3.75 4.26472 6.10051 2.25 9 2.25C11.8995 2.25 14.25 4.26472 14.25 6.75",
    stroke: "#8790A1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12.75V13.35C14.25 14.6755 12.9068 15.75 11.25 15.75H9.75",
    stroke: "#8790A1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.4e4b6699bbad7dbf2e097b166522ac9c.svg";
export { ForwardRef as ReactComponent };